export default __webpack_public_path__ + "static/testimonial-ricker@2x-5c14a378a68e35fce203b7c7e8599e20.png";